export default __webpack_public_path__ + "static/media/title.cfcff205.png";